export default __webpack_public_path__ + "static/hacktoberfest-prep-easing-into-cncf-open-source-projects-4235bc065f9de3d12207f00c121cf50f.pdf";